import { useEffect, useState, type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { painelApi, type PainelMe } from '@/api/painel';
import { PainelMeContext } from './PainelContext';

/**
 * Guard das rotas `/painel/*` (molde do RequireAuth). Só entra quem o backend
 * diz que é membro de alguma organização parceira. Painel desligado (404),
 * sem vínculo ou erro → volta pro Perfil. Quem decide o acesso é SEMPRE o
 * backend (cada endpoint revalida o vínculo); isto só evita a tela vazia.
 */
export function RequirePainel({ children }: { children: ReactNode }) {
  const [me, setMe] = useState<PainelMe | null | 'none'>(null);

  useEffect(() => {
    let cancelled = false;
    painelApi
      .me()
      .then((m) => {
        if (!cancelled) setMe(m.orgs.length > 0 ? m : 'none');
      })
      .catch(() => {
        if (!cancelled) setMe('none');
      });
    return () => {
      cancelled = true;
    };
  }, []);

  if (me === 'none') return <Navigate to="/profile" replace />;
  if (me === null) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-bow-cream text-sm text-bow-royal/55">
        Carregando painel…
      </div>
    );
  }
  return <PainelMeContext.Provider value={me}>{children}</PainelMeContext.Provider>;
}
